import { Component, Input, OnInit } from "@angular/core";
import { KeyGenerator } from 'src/app/util/keyGenerator';
@Component({
  selector: "rdf-form-viewer",
  templateUrl: "./form-viewer.component.html",
  styleUrls: ["./form-viewer.component.css"],
})
export class FormViewerComponent implements OnInit {
  @Input() stage;
  @Input() emittables;
  blockName;
  stageKeys = []
  keyGenerator: KeyGenerator;
  constructor() { }

  ngOnInit() {
    this.keyGenerator = new KeyGenerator()
  }

  getBlocksNumberArray() {
    return Array.from({ length: this.stage?.blocks?.length }, (_, i) => i + 1)
  }

  addBlock() {
    if (!this.stage.blocks) this.stage.blocks = [];
    this.stage.blocks.push({ name: this.blockName, rows:[], columns:[], key: this.keyGenerator.generateKey(this.stage, 'block') });
    this.blockName = undefined;
  }

  moveBlock(val, block) {
    let blocks = this.stage.blocks
    const currentIndex = blocks.findIndex((blc) => blc.key === block.key);
    const [objToMove] = blocks.splice(currentIndex, 1);
    blocks.splice(val, 0, objToMove);
  }

  deleteBlock(block) {
    this.stage.blocks = this.stage.blocks.filter(elem => elem.key !== block.key)
  }
  setSumTotals(val, block) {
    block.sumTotals = val
  }
  setBlockType(val, block) {
    block.colType = val
  }

}
